module.exports = __webpack_public_path__ + "img/logo_app.22eaa509.png";